export const LOAD_INIT = 'coverage/LOAD_INIT';
export const LOAD_SUCCESS = 'coverage/LOAD_SUCCESS';
export const LOAD_FAIL = 'coverage/LOAD_FAIL';

export const LOAD_PROVIDER_INIT = 'provider/LOAD_INIT';
export const LOAD_PROVIDER_SUCCESS = 'provider/LOAD_SUCCESS';
export const LOAD_PROVIDER_FAIL = 'provider/LOAD_FAIL';

const ENDPOINT = '/api/coverage';

const initialState = {
  payload: {},
  providers: {}
};

export default function coverage(state = initialState, { type, payload }) {
  if (type === LOAD_SUCCESS) {
    return {
      ...state,
      payload
    };
  }

  if (type === LOAD_PROVIDER_SUCCESS) {
    return {
      ...state,
      providers: payload
    };
  }

  return state;
}

export function getCoverage(addressId) {
  return {
    types: [LOAD_INIT, LOAD_SUCCESS, LOAD_FAIL],
    promise: client => client.get(`${ENDPOINT}/${addressId}`)
  };
}

export function getCoveragByProvider(addressId, provider) {
  return {
    types: [LOAD_PROVIDER_INIT, LOAD_PROVIDER_SUCCESS, LOAD_PROVIDER_FAIL],
    promise: client => client.get(`${ENDPOINT}/${addressId}${provider ? `/${provider}`: ''}`)
  };
}
